import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col, Button} from 'react-bootstrap'
import PpcLoadForm from './ppc-load-form'
import PpcLoadDetails from './ppc-load-details'
import BackLink from '../../../common/back-link/index'
import PageTitle from '../../../common/page-title/index'
import {getPpcUserLoad} from '../../../../actions/ppc'
import {history} from '../../../../store';

class PpcLoad extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.userId = +this.props.match.params.userId;
    this.loadId = +this.props.match.params.loadId;
    this.props.dispatch(getPpcUserLoad(this.userId, this.loadId));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_ppc.management.load'));
    this.props.dispatch({type: 'CLEAR_EDIT_PPC_LOAD'});
  }

  render() {
    return (
      <Grid bsClass="container" fluid className="ppc-user">
        <Row>
          <Col lg={12}>
            <BackLink href={`/admin/ppc/management/${this.userId}`}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Edit prepaid card load</PageTitle>
          </Col>
        </Row>
        <Row className="user-info">
          <Col lg={12}>
            {
              this.props.load.attributes && <PpcLoadDetails load={this.props.load}/>
            }
          </Col>
        </Row>
        {
          this.props.load.attributes && <PpcLoadForm load={this.props.load}
                                                     statuses={this.props.statuses}
                                                     userId={this.userId}
                                                     loadId={this.loadId}/>
        }
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    load:     state.ppc.load,
    statuses: state.ppc.orderStatuses,
    fetched:  state.ppc.fetched,
    fetching: state.ppc.fetching,
  };
};

export default connect(mapStateToProps)(PpcLoad);



// WEBPACK FOOTER //
// ./src/components/admin/ppc/load/index.jsx